import React from "react";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";

type NavigationElementProps = {
  title: string;
  route: string;
  className?: string;
  children?: React.ReactNode;
};

const NavigationElement = ({ title, route, className, children }: NavigationElementProps) => {
  const location = useLocation();
  const currentLocationPathName = location.pathname;
  const isActive = currentLocationPathName.includes(route);
  const navigationClassName = classNames(className, "hover:bg-body py-sm px-2xl", {
    active: isActive,
    "bg-body": isActive,
  });

  return (
    <Link to={route}>
      <li className={navigationClassName}>
        <div className="inline-block text-muted hover:text-muted focus:text-muted focus:no-underline">{title}</div>

        {children}
      </li>
    </Link>
  );
};

export default NavigationElement;
